import { useDispatch } from 'react-redux'
import { showErrorBanner } from 'shared/actions/ui/actions'
import { BannerProps } from 'shared/components/Context/UserContext'
import { parseError } from 'shared/helpers/errors'

export function useErrorMessage() {
  const dispatch = useDispatch()

  // TODO: Fix the type of e in the components that use this hook
  return function errorMessage(e: BannerProps | any) {
    if (
      e?.message &&
      typeof e.message === 'string' &&
      !e.message.toLowerCase?.().includes('request failed')
    ) {
      return dispatch(showErrorBanner({ message: e.message, title: e.title }))
    }
    dispatch(showErrorBanner({ message: parseError(e) }))
  }
}
